import React from 'react';
import { TextField } from '@wix/wix-ui-tpa/cssVars';
import { setAddNewFolderMoveObservable } from '../../Services/Move/Move.service';
import { startMoving } from '../../Services/Move/MovingProccess';
import { st, classes } from './MoveWrapper.st.css';
import { useTranslation } from '@wix/yoshi-flow-editor';

const MoveAddNewFolderRowClick = (props: any) => {
  const { compId, movingToFolderId, movingToFolderName, isMobile } = props;
  const { t } = useTranslation();
  return (
    <>
      <TextField
        className={st(classes.addMoveFolder, { isMobile })}
        autoFocus
        placeholder={t('app.widget.move.createNewFolder.input.placeHolder')}
        onFocus={() => {
          startMoving(compId, movingToFolderId, movingToFolderName);
        }}
        onChange={(e: any) => {
          setAddNewFolderMoveObservable({
            status: true,
            folderName: e.target.value,
          });
        }}
      />
    </>
  );
};

export default MoveAddNewFolderRowClick;
